import { Injectable } from "@angular/core";
import { RequestOptions, URLSearchParams } from "@angular/http";
import { CONFIGURATION } from "../../app.constants";
import { User, Diocese, Organisation, SecretQuestion, JobTitle } from "../../models";
import { Observable } from "rxjs/Observable";
import { HttpDataService } from "../../services/shared";
import { CommonUtility } from "../../utils/commonUtility";

@Injectable()
export class RegistrationService {

    constructor(private httpData: HttpDataService, private commonUtility: CommonUtility) { }

    public Save(user: User): Observable<User> {
        user.dateOfBirth = this.commonUtility.ConvertLocalDateToUTCDate(user.dateOfBirth);
        return Observable.create((observer) => {
            this.httpData.post(CONFIGURATION.baseUrls.apiUrl + "account", JSON.stringify(user))
                .map(response => <User>response.json())
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

    public GetJobTitles(): Observable<JobTitle[]> {
        let dataUrl = `${CONFIGURATION.baseUrls.apiUrl}common/getpositions`;

        return Observable.create((observer) => {
            this.httpData.get(dataUrl)
                .map(response => <JobTitle[]>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

    // TODO: Get it from common data service
    public GetDioceseList(): Observable<Diocese[]> {
        return Observable.create((observer) => {
            this.httpData.get(CONFIGURATION.baseUrls.apiUrl + "v1/EF/SearchDiocese?$orderby=DioceseName asc")
                .map(response => <Diocese[]>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

    public GetOrganisationsByDiocese(diocesePublicId: string): Observable<Organisation[]> {
        return Observable.create((observer) => {
            this.httpData.get(CONFIGURATION.baseUrls.apiUrl + "v1/EF/GetDiocese/" + diocesePublicId)
                .map(response => <Organisation[]>response.json().result.organisations)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

    public GetOrganisationsByDioceseId(dioceseId: string): Observable<Organisation[]> {
        const enterpriseConnectionName = ""; // Return All organisations until Auth0 connectionName issue is rectified
        let enterpriseConnectionNameParam: string = enterpriseConnectionName ? `&enterpriseConnectionName=${encodeURIComponent(enterpriseConnectionName)}` : "";
        let select: string = "$select=PublicId,Name,LocationSuburb,LocationPostCode,ExternalId,IsDioceseOffice";
        let filter: string = `&$filter=DioceseId eq ${dioceseId} and IsActive eq true`;
        let order: string = "&$orderby=ExternalId asc";
        let dataUrl = CONFIGURATION.baseUrls.apiUrl + "v1/EF/SearchOrganisation?" + select + filter + order + enterpriseConnectionNameParam;
        return Observable.create((observer) => {
            this.httpData.get(dataUrl)
                .map(response => <Organisation[]>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

    public GetSecretQuestions(): Observable<SecretQuestion[]> {
        return Observable.create((observer) => {
            this.httpData.get(CONFIGURATION.baseUrls.apiUrl + "common/getsecretquestions")
                .map(response => <SecretQuestion[]>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

    public GetAccountGetSecretQuestions(): Observable<SecretQuestion[]> {
        return Observable.create((observer) => {
            this.httpData.get(CONFIGURATION.baseUrls.apiUrl + "common/getsecretquestions")
                .map(response => <SecretQuestion[]>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

    public GenerateUserIdForNewAccount(firstName, lastName): Observable<string> {
        if (lastName === undefined) lastName = "";
        if (firstName === undefined) firstName = "";
        return Observable.create((observer) => {
            this.httpData.get(CONFIGURATION.baseUrls.apiUrl + "account/GenerateNewUserId?firstName=" + firstName + "&lastName=" + lastName)
                .map(response => <string>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

    public IsDuplicateAccount(firstName, lastName, dateOfBirth, mobile): Observable<string> {
        let params = new URLSearchParams();
        if (firstName) params.set("firstName", firstName);
        if (lastName) params.set("lastName", lastName);
        if (mobile) params.set("mobile", mobile);
        if (dateOfBirth) params.set("dateOfBirth", dateOfBirth);
        
        let args = new RequestOptions({
            search: params
        });
        return Observable.create((observer) => {
            this.httpData.get(CONFIGURATION.baseUrls.apiUrl + "account/IsDuplicateUserAccount", args)
                .map(response => <string>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }

    public IsNameCombinationLocked(firstName, lastName): Observable<string> {
        let params = new URLSearchParams();
        if (firstName) params.set("firstName", firstName);
        if (lastName) params.set("lastName", lastName);
        
        let args = new RequestOptions({
            search: params
        });
        return Observable.create((observer) => {
            this.httpData.get(CONFIGURATION.baseUrls.apiUrl + "account/IsNameCombinationLocked", args)
                .map(response => <string>response.json().result)
                .subscribe((userData) => {
                    observer.next(userData);
                }, (error) => observer.error(error),
                () => observer.complete());
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/registration/registration.service.ts